import { useContext } from "react";
import SideNavContext from "src/contexts/SideNavContext";

const useSideNav = () => useContext(SideNavContext);

export default useSideNav;
